import { Container, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { BsArrowRight } from 'react-icons/bs'
import { LRContainer } from 'style/styledItems'
import { HomeCardsContainer } from './style'

function HomeCards() {
  const { t } = useTranslation()
  const img1 = 'https://image.anecdobio.com/home_circle1.jpg'
  const img2 = 'https://image.anecdobio.com/home_circle2a.jpg'
  const img3 = 'https://image.anecdobio.com/home_circle3.jpg'

  return (
    <HomeCardsContainer>
      <Container className="h-100">
        <h3>{t('home_hero_description')}</h3>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('home_card1_title')}</h2>
            <h4>{t('home_card1_description')}</h4>
            <a href="/your-book">
              {t('yourbook')} <BsArrowRight />
            </a>
          </div>
          <div className="lr-img lr-item">
            <Image src={img1} />
          </div>
        </LRContainer>
        <LRContainer imgPos="R">
          <div className="lr-content lr-item">
            <h2>{t('home_card2_title')}</h2>
            <h4>{t('home_card2_description')}</h4>
            <a href="/how-it-works">
              {t('howitworks')} <BsArrowRight />
            </a>
          </div>
          <div className="lr-img lr-item">
            <Image src={img2} />
          </div>
        </LRContainer>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('home_card3_title')}</h2>
            <h4>{t('home_card3_description')}</h4>
            <a href="/get-started">
              {t('getstarted')} <BsArrowRight />
            </a>
          </div>
          <div className="lr-img lr-item">
            <Image src={img3} />
          </div>
        </LRContainer>
      </Container>
    </HomeCardsContainer>
  )
}

export default HomeCards
